export default __webpack_public_path__ + "static/290-320-893be2548e16251a5aa926b3308b5f9d.jpg";